const ROLE = {
  SUPER_ADMIN: 0,
  HUB_ADMIN: 1,
  TEACHER: 2,
  STUDENT: 3,
};

export { ROLE };
